// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from 'app/components/CRUD/EditEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/** Same limits as the add form — public.fare_media_type column widths. */
const inputs = [
  {
    name: 'en_name',
    labelKey: 'NameEnglish',
    type: 'text',
    required: true,
    maxLength: 45,
  },
  {
    name: 'ar_name',
    labelKey: 'NameArabic',
    type: 'text',
    required: true,
    maxLength: 45,
  },
  { name: 'is_test', labelKey: 'IsTest', type: 'checkbox', hint: 'IsTestHint' },
  { name: 'is_old', labelKey: 'IsOld', type: 'checkbox', hint: 'IsOldHint' },
];

const UpdateFareMediaType: React.FC = () => {
  const buildUpdatePayload = formValues => ({
    en_name: formValues.en_name,
    ar_name: formValues.ar_name,
    // Sent as real booleans, so unchecking a box actually clears the flag.
    is_test: !!formValues.is_test,
    is_old: !!formValues.is_old,
  });

  return (
    <EditEntity
      pageTitle="EditFareMediaType"
      fetchApiUrl={CONFIG_PATHS.fareMediaTypeById}
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={inputs}
      dropdowns={[]}
      buildUpdatePayload={buildUpdatePayload}
      updateApiUrl={CONFIG_PATHS.fareMediaTypeById}
      updateApiMethod="PATCH"
      successMessage="FareMediaTypeUpdatedSuccessfully"
      // EditEntity redirects to backUrl on save, so this lands on the detail page.
      backUrl={`${CONFIG_ROUTES.fareMediaTypes}/:id`}
      subsystemName="FareMediaTypes"
      permissionSystem="masterConfig"
    />
  );
};

export default UpdateFareMediaType;
